import { HttpClient } from '@angular/common/http';
import {
  ComponentFactoryResolver,
  Injectable,
  Injector,
  ViewContainerRef,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  BehaviorSubject,
  map,
  Observable,
  ReplaySubject,
  Subject,
  takeUntil,
} from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import axios from 'axios';
import {
  IConfigRes,
  IProfileMassage,
  IUserProfile,
  IWalletUrlRes,
} from 'src/app/common/interfaces/IProfile';
import { ProfileService } from 'src/app/common/services/profile.service';
import { IDownLoad } from 'src/app/modules/contract-admin/contract-admin-interface';
import { StrongFBHttpService } from 'src/app/StrongFB/services/StrongFB-http.service';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';
import {
  APIResponseNotification,
  ICreateHashBody,
  APIResponse,
} from '../common/interfaces';
import {
  ICreateHashRes,
  LoadingTypes,
  MimeTypes,
  ScreenMode,
  usage,
} from '../common/types';
import { HttpService } from './http.service';
import { SettingsService } from './settings.service';
import { TransmitService } from './transmit.service';
import {
  addCurrency,
  ComponentLookupRegistry,
  setUserName,
  warning,
} from '../common/public';
import { NbDialogService } from '@nebular/theme';
import { PrivacyComponent } from 'src/app/modules/public/privacy/privacy.component';
import { AuthService as PermissionService } from 'src/app/common/services/auth.service';
import { ITags } from 'src/app/modules/lawyer-managment/comment.interface';
import { Block } from 'notiflix/build/notiflix-block-aio';
import { checkAndDoByInterval } from 'src/app/StrongFB/common/StrongFB-common';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  pageContainer: ViewContainerRef;
  screenMode = new BehaviorSubject<ScreenMode>('desktop');
  unreadNotificationsCount = 0;
  unreadmessage = 0;
  totalNotif;
  notifications = [];
  userWalletInventory: string;
  lastNotificationOverall: number;
  unridedNotification: number;
  profileInfo: IUserProfile = {
    avatar: '',
    first_name: '',
    is_complete: false,
    last_name: '',
    national_code: '',
    phone: '',
    pk: 0,
    user_type: '',
    otp_register: false,
    permissions: [],
    email: '',
    is_active: false,
    last_activity: 0,
    groups: [],
    goftino_id: '',
  };
  profile = new ReplaySubject<IUserProfile>(null);
  static CHANGEABLE_URLS: { charge_wallet?: string } = {};
  notifier = new Subject<void>();
  faNums = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  faDigitsRegex = /[۰۱۲۳۴۵۶۷۸۹]/g;
  /************************************** */
  constructor(
    private http: HttpService,
    private title: Title,
    public authService: AuthService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private _router: Router,
    private _profileService: ProfileService,
    private _httpClient: HttpClient,
    private transmit: TransmitService,
    private _http: StrongFBHttpService,
    private _permissionService: PermissionService,
    private dialogService: NbDialogService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.setWalletDynamicUrl();

    // =>listen on notifications overall
    this.transmit
      .listen<APIResponseNotification>('notifications-overall')
      .subscribe((it) => {
        if (!it) return;

        this._setMetaRequest(it);
        this.lastNotificationOverall = new Date().getTime();
      });

    setInterval(async () => {
      const now = new Date().getTime();
      // =>check for get last notif overall
      if (
        (!this.lastNotificationOverall ||
          now >=
            this.lastNotificationOverall +
              SettingsService.UPDATE_STATE_INTERVAL) &&
        this.authService.isAuthenticated()
      ) {
        this.refreshOverallNotifications();
      }
    }, 1000);

    this.getUserProfileInfo();
    this.transmit
      .listen('new-login' as any)
      .pipe(takeUntil(this.notifier))
      .subscribe((it) => {
        if (!it) return;
        this.getUserProfileInfo();
      });

    this.http.notifSubject.pipe(takeUntil(this.notifier)).subscribe((notif) => {
      this.unreadmessage = notif.message;
      this.unreadNotificationsCount = notif.notification;
      this.totalNotif = this.unreadmessage + this.unreadNotificationsCount;
    });
  }
  /************************************** */
  private _setMetaRequest(meta: APIResponseNotification) {
    if (!meta || meta.__failed) return;
    this.unreadNotificationsCount = meta.unread_notification;
    this.unreadmessage = meta.unread_message;
    this.userWalletInventory = addCurrency(meta.wallet);
  }
  /************************************** */
  // async refreshOverallNotifications() {
  //   this.lastNotificationOverall = new Date().getTime();
  //   // =>call overall api
  //   let res = await this.http.sendPromise({
  //     method: 'GET',
  //     path: 'notification/overall/',
  //   }, false, false, false);

  // }
  async refreshOverallNotifications() {
    this.lastNotificationOverall = new Date().getTime();
    let res = await this.http.getSuccessResult<APIResponse>(
      {
        method: 'GET',
        path: 'notification/overall/',
      },
      undefined,
      true,
      false,
      false
    );

    if (res?.meta && !res.meta?.__failed) {
      let object: APIResponseNotification = {
        unread_notification: res.meta.unread_notification,
        unread_message: res.meta.unread_message,
        wallet: res.meta.wallet,
      };
      this.transmit.emit('notifications-overall', object);
    }
  }
  /************************************** */
  async loadComponent<T extends string = string>(componentName: T) {
    return new Promise((res) => {
      let setContainerInterval = setInterval(async () => {
        if (!this.pageContainer || !this.componentFactoryResolver) return;
        // =>detach all before views
        // for (let i = 0; i < this.pageContainer.length; i++) {
        //   this.pageContainer.detach(i);
        // }
        let componentClass = ComponentLookupRegistry.get(componentName);
        if (!componentClass) {
          warning('not found component', componentName);
          clearInterval(setContainerInterval);
          res(undefined);
          return;
        }
        this.pageContainer.clear();
        const factory =
          this.componentFactoryResolver.resolveComponentFactory(componentClass);
        const componentInstance = this.pageContainer.createComponent(
          factory,
          0,
          this.injector
        );

        clearInterval(setContainerInterval);
        res(componentInstance);
      }, 150);
    });
  }
  /************************************** */
  //  Observable<IProfileMassage> {
  //   return this._httpClient.get<IProfileMassage>('accounts/profile/').pipe(map((response) => {
  //     this.profile.next(response.data)
  //     return response;
  //   }));
  // }
  async getuserinfo() {
    const res = await this.http.getSuccessResult<IUserProfile>(
      {
        method: 'GET',
        path: 'accounts/profile/',
      },
      {
        avatar: '',
        first_name: '',
        is_complete: false,
        last_name: '',
        national_code: '',
        phone: '',
        pk: 0,
        user_type: '',
        otp_register: false,
        permissions: [],
        email: '',
        is_active: false,
        last_activity: 0,
        goftino_id: '',
      }
    );

    return res;
  }
  /************************************** */
  async getTagsList() {
    return await this.http.getSuccessResult<ITags[]>(
      {
        method: 'GET',
        path: 'tag/tag/',
        body: { page_size: 100 },
      },
      [
        {
          name: '',
          uuid: '',
        },
      ]
    );
  }

  // private _getNotificationsApi(): Observable<any> {
  //     return this._apiService.getNotifications().pipe(
  //         map((data) => {
  //             if (data && data.data && data.data.length) {
  //                 this.transmit.emit('notifications-overall', data?.notification);
  //                 this.unridedNotification = data.paginate.total_records;
  //                 return data.data;
  //             } else {
  //                 return [];
  //             }
  //         })
  //     );
  // }

  // loadNotifications() {
  //     if (localStorage.getItem("access_token")) {
  //         this._getNotificationsApi().subscribe((data) =>
  //             this._createNotifications(data)
  //         );
  //     }
  // }

  // private _createNotifications(notifications) {
  //     const limit = 5;
  //     this.notifications = [];
  //     notifications.map((notif) => {
  //         if (this.notifications.length < limit) {
  //             this.notifications.push({
  //                 title: notif.title,
  //                 description: this.cutString(notif.description),
  //                 uuid: notif.uuid,
  //             });
  //         }
  //     });
  // }

  // cutString(str) {
  //     if (str) {
  //         if (str.length > 120) {
  //             return str.substring(0, 120) + '...';
  //         }
  //         else {
  //             return str;
  //         }
  //     } else {
  //         return str;
  //     }
  // }
  /************************************** */
  async getUserProfileInfo() {
    this.transmit.emit('profile-data' as any, false);
    if (this.authService.isAuthenticated()) {
      let res = await this.getuserinfo();
      if (res.data) {
        this.profileInfo = res.data;
        this.transmit.emit('profile-data', true);
        if (
          this.profileInfo.login_counter < 2 &&
          (localStorage.getItem('user_confirm_policy') === 'false' ||
            !localStorage.getItem('user_confirm_policy')) &&
          !window.location.href.includes('privacy')
        ) {
          this.dialogService.open(PrivacyComponent, {
            hasBackdrop: false,
            context: { dialog: true },
          });
        }
        this._permissionService.setPermission(
          res.data.permissions,
          res.data.groups
        );
      }
    }
  }

  isLoginCheck() {
    return this.profileInfo.pk !== 0;
  }

  goToPaymentPage(hash: string): void {
    this._router.navigateByUrl('payment/checkout/' + hash);
  }

  createHash(body: ICreateHashBody): Promise<APIResponse<ICreateHashRes>> {
    return this.http.getSuccessResult<ICreateHashRes>(
      {
        method: 'POST',
        path: 'payment/payment-hash/',
        body,
      },
      {
        data: {
          product_uuid: '',
          usage: 'learning',
          price: 0,
        },
        hash: '',
        message: '',
        notification: {
          unread_notification: 0,
          unread_message: 0,
        },
        responseTime: 0,
        statusCode: 0,
        success: false,
      }
    );
  }
  /************************************** */
  //download File
  downloadFile<T = IDownLoad>(
    url: string,
    method: string,
    title: string,
    format?: string,
    params?: T
  ) {
    return new Promise((res) => {
      axios({
        url: environment.baseUrl + url,
        method: method,
        params: params,
        headers: {
          Authorization: this._http.getToken(),
        },
        responseType: 'blob',
      }).then((response) => {
        const href = URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', title + '.' + format);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
        return res(true);
      });
    });
  }
  /************************************** */
  async setWalletDynamicUrl() {
    const walletUrlRes = await this.http.getSuccessResult<IWalletUrlRes>({
      method: 'GET',
      path: 'get-dynamic-links/',
      noAuth: true,
    });
    EnvironmentService.CHANGEABLE_URLS = walletUrlRes?.data;
  }
  /************************************** */
  async uploaderInfo(key: string) {
    //key: 'sth/'
    const configData = await this.http.getSuccessResult({
      method: 'GET',
      path: 'config/system-config/',
      body: {
        namespace: 'upload_file',
        type: 'object',
        key: '/api/v1/upload-file/' + key,
      },
    });
    return configData?.data.value;
  }
  /************************************** */
  needUserLogin(callbackUrl?: string) {
    if (callbackUrl) {
      this._router.navigateByUrl(
        `/auth/logout?next=${encodeURIComponent(callbackUrl)}`
      );
    } else {
      this._router.navigateByUrl(`/auth/logout`);
    }
  }
  /************************************** */
  forceUserAuthenticated() {
    if (this.authService.isAuthenticated()) {
      return true;
    } else {
      this.needUserLogin(this._router.url);
      return false;
    }
  }
  /************************************** */
  goToAuthorizedPage(pageUrl: string) {
    if (this.authService.isAuthenticated()) {
      this._router.navigateByUrl(pageUrl);
      return true;
    } else {
      this.needUserLogin(pageUrl);
      return false;
    }
  }
  /************************************** */
  checkUserPermissions(permissions: string[] | string) {
    if (!Array.isArray(permissions)) {
      permissions = [permissions];
    }

    let userPermissions = this.profileInfo.permissions;
    if (userPermissions.find((i) => i.name === 'full_access')) {
      return true;
    }
    for (const perm of permissions) {
      if (userPermissions.find((i) => i.name === perm)) {
        return true;
      }
    }
    return false;
  }

  goToHomePage() {
    if (environment.production) {
      window.location.href = environment.djangoUrl;
    } else {
      window.location.href = '/';
    }
  }
  logout() {
    const url = window.location.href;
    if (!url.includes('/auth/log')) {
      const next = this.activatedRoute.snapshot.queryParamMap.get('next') || url;
      this._router.navigate(['/auth/logout'], {
        queryParams: { next: encodeURIComponent(next) },
      });
    }
  }

  extractRelateiveUrl(fullUrl: string) {
    const url = new URL(fullUrl);
    return url.pathname + url.search;
  }

  goToChat(
    type: 'consultation' | 'contract' | 'complaint' | 'petition' | 'judicial',
    role: 'admin' | 'user' | 'lawyer',
    uuid: string,
    version: string = 'v1',
    navigate = true
  ) {
    let url: string = '';
    if (type == 'consultation') {
      switch (role) {
        case 'admin':
          url = `/consultation-${role}/offline-${role}-consultation/${uuid}?version=${version}`;
          break;
        case 'lawyer':
          url = `/consultation-${role}/offline-consultation-lawyer-page/${uuid}?version=${version}`;
          break;
        case 'user':
          url = `/consultation-${role}/offline-consultation/${uuid}?version=${version}`;
          break;
      }
    } else if (type == 'contract') {
      url = `/contract-${role}/contract-chat/${uuid}?version=${version}`;
    } else if (type === 'complaint') {
      url = `/complaint-${role}/complaint-chat/${uuid}?version=${version}`;
    } else if (type === 'petition') {
      url = `/petition-${role}/petition-chat/${uuid}?version=${version}`;
    } else if (type === 'judicial') {
      url = `/judicial-${role}/judicial-chat/${uuid}?version=${version}`;
    } else {
      return undefined;
    }
    if (navigate) {
      this._router.navigateByUrl(url);
    }
    return url;
  }

  digitsFaToEn(value: string) {
    return String(value).replace(
      this.faDigitsRegex,
      (char) => `${this.faNums.indexOf(char)}`
    );
  }
}

export function productListUrl(productName: usage) {
  let url: string;
  switch (productName) {
    case 'bill':
      url = '/judicial-user/judicial-main';
      break;
    case 'other_judicial_request':
      url = '/judicial-user/judicial-main';
      break;
    case 'declaration':
      url = '/judicial-user/judicial-main';
      break;
    case 'ready_contract':
      url = '/contract-user/contract-main';
      break;
    case 'custom_contract':
      url = '/contract-user/contract-main';
      break;
    case 'smart_contract':
      url = '/contract-user/contract-main';
      break;
    case 'contract_meeting':
      url = '/contract-user/contract-main';
      break;
    case 'contract_expertise':
      url = '/contract-user/contract-main';
      break;
    case 'ready_petition':
      url = '/petition-user/user-petition-list';
      break;
    case 'custom_petition':
      url = '/petition-user/user-petition-list';
      break;
    case 'petition':
      url = '/petition-user/user-petition-list';
      break;
    case 'ready_complaint':
      url = '/complaint-user/complaint-main-user';
      break;
    case 'custom_complaint':
      url = '/complaint-user/complaint-main-user';
      break;
    case 'smart_complaint':
      url = '/complaint-user/complaint-main-user';
      break;
    case 'face_to_face_consultation':
      url = '/consultation-user/consultation-user';
      break;
    case 'online_consultation':
      url = '/consultation-user/consultation-user';
      break;
    case 'offline_consultation':
      url = '/consultation-user/consultation-user';
      break;
    case 'learning':
      url = '/education-user/education-list';
      break;
    case 'package':
      url = '/package-user/user-package-list';
      break;
  }
  return url;
}

export function toggleLoading(
  containerClassName: string,
  isLoading: boolean,
  loadingType: LoadingTypes = 'circle'
) {
  if (isLoading) Block[loadingType](containerClassName);

  if (!isLoading)
    checkAndDoByInterval(
      () => document.querySelector(containerClassName) !== null,
      () => {
        Block.remove(containerClassName);
      },
      5
    );
}
